// import { success } from "toastr";
import vi from './vi.js';
import en from './en.js';
import ja from './ja.js';

const messages = { ...vi, ...en, ...ja};

export default messages;